import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button,
    Row,
    Spin
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useEffect, useState } from 'react';
import { createBeaconStore, updateBeaconStore } from '@/apiCalls/apiCalls';
import { errorNotification, successNotification } from '@/utils/Notification';
import { BeaconStore } from './BeaconStoreColumns';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';
import axios from 'axios';



const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
interface ProductsDrawerProps {
    showUpdateBeaconStoresDrawer: boolean;
    setShowUpdateBeaconStoresDrawer: React.Dispatch<React.SetStateAction<boolean>>
    BeaconStore: BeaconStore
    getBeaconStores: any
    setBeaconStoreData: React.Dispatch<React.SetStateAction<BeaconStore | undefined>>
}

const UpdateBeaconStoresDrawer: React.FC<ProductsDrawerProps> = ({ showUpdateBeaconStoresDrawer, setShowUpdateBeaconStoresDrawer, BeaconStore, getBeaconStores, setBeaconStoreData }) => {
    const onCLose = () => {
        setShowUpdateBeaconStoresDrawer(false)
        setBeaconStoreData(undefined)
    }
    const [submitting, setSubmitting] = useState(false)
    const [form] = Form.useForm()
    const navigate = useNavigate()
    const location = useLocation()
    const axiosPrivate = useAxiosPrivate()


    useEffect(() => {
        const setFormValues = async () => {
            form.setFieldsValue(BeaconStore)
        }

        if (BeaconStore) {
            setFormValues()
        }
    }, [BeaconStore, form])



    const getClientIPAndURL = async () => {
        try {

            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }

    const onFinish = (beaconStore: any) => {
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.put(`/api/v1/beaconStore/${beaconStore.id}`, beaconStore, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then(() => {
            if (isMounted) {
                onCLose()
                successNotification(
                    "Beacon Store successfully updated",
                    `${beaconStore.name} was updated`,
                    'topRight'
                )
            }
            getBeaconStores()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2))
    }

    return (
        <>

            <Drawer
                title="update Beacons Stores"
                width={720}
                onClose={onCLose}
                open={showUpdateBeaconStoresDrawer}
                bodyStyle={{ paddingBottom: 80 }}
                style={{
                    backgroundColor: 'white',
                    transition: 'transform 0.3s ease, opacity 0.3s ease'
                }}
                maskStyle={{
                    transition: 'opacity 0.3s ease'
                }}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={onCLose} style={{ marginRight: 8 }}>
                            Cancel
                        </Button>
                    </div>
                }
            >
                <Form layout="vertical"
                    onFinishFailed={onFinishFailed}
                    onFinish={onFinish}
                    form={form}
                    initialValues={BeaconStore}
                    hideRequiredMark>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="name"
                                label="name"
                                rules={[{ required: true, message: 'Please enter name' }]}
                            >
                                <Input
                                    placeholder="Please enter name"
                                    className='focus:border-green-500 hover:border-green-500'
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="description"
                                label="description"
                                rules={[{ required: true, message: 'Please enter name' }]}
                            >
                                <Input
                                    placeholder="Please enter name"
                                    className='focus:border-green-500 hover:border-green-500'
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="parent_id"
                                label="parent id"
                                hidden={true}
                                rules={[{ required: true, message: 'Please enter name' }]}
                            >
                                <Input
                                    placeholder="Please enter name"
                                    className='focus:border-green-500 hover:border-green-500'
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="featured"
                                label="featured"
                                hidden={true}
                                rules={[{ required: true, message: 'Please enter name' }]}
                            >
                                <Input
                                    placeholder="Please enter name"
                                    className='focus:border-green-500 hover:border-green-500'
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="id"
                                label="id"
                                hidden={true}
                                rules={[{ required: true, message: 'Please enter name' }]}
                            >
                                <Input
                                    placeholder="Please enter name"
                                    className='focus:border-green-500 hover:border-green-500'
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="menu"
                                label="menu"
                                hidden={true}
                                rules={[{ required: true, message: 'Please enter name' }]}
                            >
                                <Input
                                    placeholder="Please enter name"
                                    className='focus:border-green-500 hover:border-green-500'
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                                    Submit
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        {submitting && <Spin indicator={antIcon} />}
                    </Row>
                </Form>
            </Drawer>
        </>
    )
}

export default UpdateBeaconStoresDrawer;


